import { Box, Button, TextField, InputLabel } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddNewTrainings } from "../../../../api/AuthenticationServices";
const imageConvert = require("../../../imageConvert");
const NewTrainings = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  const handleFileChange = async (event) => {
    const base64 = await imageConvert(event.target.files[0]);
    setFile(base64);
  };
  const sendData = async (e, values) => {
    console.log(values);
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", values.trainingName);
      formData.append("purpose", values.trainingPurpose);

      const fileConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
        },
      };
      const res = await AddNewTrainings(formData, fileConfig);

      if (res.data.status === "success") {
        alert(res.data.message);
        navigate("/admin/viewtrainings");
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="NEW TRAININGS" subtitle="Create a New Training" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Training Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.trainingName}
                  name="trainingName"
                  error={!!touched.trainingName && !!errors.trainingName}
                  helperText={touched.trainingName && errors.trainingName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Purpose of Training"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.trainingPurpose}
                  name="trainingPurpose"
                  error={!!touched.trainingPurpose && !!errors.trainingPurpose}
                  helperText={touched.trainingPurpose && errors.trainingPurpose}
                  sx={{ gridColumn: "span 2" }}
                />

                <InputLabel id="pl-gen" sx={{ gridColumn: "span 2" }}>
                  Upload Photo
                </InputLabel>
                <input type="file" onChange={handleFileChange} />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Create New Training
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  trainingName: yup.string().required("required"),
  trainingPurpose: yup.string().required("required"),
});
const initialValues = {
  trainingName: "",
  trainingPurpose: "",
};

export default NewTrainings;
